<template>
  <div id="app">
    <router-view v-if="isRouterAlive"></router-view>
  </div>
</template>
<script>
import axios from "axios";
export default {
  provide() {
    return {
      reload: this.reload,
    };
  },
  data() {
    return {
      isRouterAlive: true,
      lastTime: null, //最后一次点击的时间
      currentTime: null, //当前点击的时间
      timeOut: 10 * 60 * 1000, //设置超时时间： 10分钟
    };
  },
  // watch: {
  //   $route: "reload",
  // },
  async created() {
    this.lastTime = new Date().getTime(); //网页第一次打开时，记录当前时间
    // 中文接口新增参数

    await this.getWebIp();
    // await this.getPk();
  },
  methods: {
    async getWebIp() {
      const fallbackIp = await this.$apis.caibian.getUserIpConfig();
      sessionStorage.setItem("webIp", fallbackIp || "103.43.184.186");
    },
    async getPk() {
      try {
        let res = await this.$apis.caibian.getPk();
        if (res.resultCode == 200) {
          console.log(res.content.pk, 1);
          sessionStorage.setItem("trip", res.content.pk);
        }
      } catch (error) {
        sessionStorage.setItem("trip", "");
      }
    },
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true;
      });
    },
    isDo() {
      this.currentTime = new Date().getTime(); //记录这次点击的时间
      if (this.currentTime - this.lastTime > this.timeOut) {
        // 这里写状态已过期后执行的操作
        localStorage.removeItem("assessment");
        this.$router.push({ path: "/loginAdmin" });
      } else {
        this.lastTime = new Date().getTime();
      }
    },
  },
};
</script>
<style lang="scss">
// @import "@/assets/font/font.css"
</style>



// WEBPACK FOOTER //
// src/App.vue